import AddToListBox from '@/components/custom/AddToListBox'

import { TabSidebar } from '@/components/custom/TabSidebar'
import { Character } from '@storyverse/shared'
import { useSpEditorProvider } from './editor/SpEditorProvider'

export default function CharacterLocationTabbar() {
    const { addCharacter, characters } = useSpEditorProvider()
    return (
        <TabSidebar
            tabs={[
                {
                    value: 'characters',
                    label: 'Characters',
                    content: (
                        <AddToListBox<Character>
                            items={characters}
                            valueExtractor={(e) => e.name}
                            title="Characters"
                            onAdd={addCharacter}
                        />
                    ),
                },
                {
                    value: 'locations',
                    label: 'Locations',
                    content: (
                        <AddToListBox<{ title: string }>
                            items={[]}
                            valueExtractor={(e) => e.title}
                            title="Locations"
                        />
                    ),
                },

                {
                    value: 'other',
                    label: 'Other',
                    content: (
                        <div className="p-4 bg-white dark:bg-gray-900 rounded-lg shadow"></div>
                    ),
                },
            ]}
            onEdit={() => console.log('Edit clicked')}
            onReset={() => console.log('Reset clicked')}
        />
    )
}
